import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewContainerRef,
    Input
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Site } from '../../../../../../../models/site';
import { SiteService } from '../../../../../../../services/site.service';
import { Helpers } from '../../../../../../../helpers';
import { BaseComponent } from '../../../../base.component';
import { PublisherDetailTab } from '../../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../../_services/data.service';
import { Paths } from '../../../../../../../models/enums';

@Component({
    selector: 'app-site',
    templateUrl: './create-site.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreateSiteComponent extends BaseComponent implements OnInit {
    site: Site = new Site();
    returnUrl: string;
    publisherName: string;

    constructor(
        private siteService: SiteService,
        private router: Router,
        private dataService: DataService,
        private route: ActivatedRoute
    ) {
        super();
        this.site.publisherId = route.snapshot.queryParams.publisherId;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.url = '/' + this.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.breadcrumb = this.publisherName;
            route.snapshot.parent.data.queryParams = { name: this.publisherName };
        }
    }

    ngOnInit() { }

    navigate(siteId = null) {
        var queryParams = { publisherId: this.site.publisherId };
        if (siteId != null) queryParams['siteId'] = siteId;
        if (this.dataService.path == Paths.Owner) {
            queryParams['tab'] = PublisherDetailTab.Inventory;
            queryParams['name'] = this.publisherName;
        }
        this.router.navigate([this.returnUrl], { queryParams: queryParams });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                title: customRules.requiredText
            }
        });
    }

    createSite() {
        var _self = this;
        Helpers.setLoading(true);
        this.siteService.create(_self.site).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            setTimeout(function() {
                _self.navigate(res.data);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/site/create-site/create-site.component.ts